import { Fragment } from "react";
import PropTypes from "prop-types";
import OfferList from "../components/OfferList.jsx";
import AvailableDurations from "app/pages/.shared/AvailableDurations";
import Loader from "app/pages/.shared/Loader.jsx";

export const SearchEngineOffers = ({
	prePackageOffers = [],
	fields = {},
	onOfferChange,
	allAvailableDurations = [],
}) => {
	const hasPrepackageOffers = prePackageOffers.length > 0;

	return (
		<div className="search-engine__offer">
			{(hasPrepackageOffers && (
				<Fragment>
					<OfferList
						offers={prePackageOffers}
						field={fields.offer}
						onOfferChange={onOfferChange}
					/>
				</Fragment>
			)) || (
				<div className="search-engine__loader">
					<Loader />
				</div>
			)}

			{allAvailableDurations.length > 0 && (
				<div className="search-engine__available-durations">
					<AvailableDurations durations={allAvailableDurations} />
				</div>
			)}
		</div>
	);
};

SearchEngineOffers.propTypes = {
	prePackageOffers: PropTypes.array,
	fields: PropTypes.object,
	onOfferChange: PropTypes.func,
	allAvailableDurations: PropTypes.arrayOf(PropTypes.number),
};
